import { Button, Card, Typography } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Tag from '../Tag';
import PopoverMenu from '../PopoverMenu/PopoverMenu';
import { EllipsisOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
const { Text } = Typography;

const WorkSpaceItem = ({ item, popoverMenuContent, setIsCollaspse }) => {
  const title = item?.title || item?.name;
  const navigate = useNavigate();
  const starredWorkspace = useSelector((state) => state.organization?.starredWorkspace?.data);
  const isStarred = starredWorkspace?.find((ele) => ele?.id === item?.id);

  const popoverMenuContentItems = popoverMenuContent(isStarred)?.filter(
    (content) => content?.id !== 'delete' || item?.meta_info?.default_private_workspace !== true
  );

  return (
    <Card
      hoverable
      styles={{
        body: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '8px',
          borderRadius: '8px',
        },
      }}
      onClick={() => {
        navigate(`/spaces/${item?.slug}`);
        setIsCollaspse(true);
      }}
    >
      {/* Avatar on the Left */}
      <Tag text={title?.slice(0, 1)?.toUpperCase()} />

      {/* Title in the Center */}
      <Text ellipsis={{ tooltip: true }} style={{ flex: 1 }}>
        {title}
      </Text>

      {/* Icons on the Right */}
      <div style={{ display: 'flex', gap: 8 }}>
        <PopoverMenu id={item?.id} content={popoverMenuContentItems} arrow={false} scroll="true" placement="right">
          <Button
            type="default"
            icon={<EllipsisOutlined />}
            style={{ border: 'none' }}
            onClick={(e) => e.stopPropagation()}
          />
        </PopoverMenu>
        {/* <Button type='default' icon={<PlusOutlined />} style={{border: 'none'}}/> */}
      </div>
    </Card>
  );
};

export default WorkSpaceItem;
